import React from 'react';
import "./css/feature.css";

function Feature() {
    return (
        <div className="feature">

            <div className="row">

                <div className="col-lg-6">

                    <img loading="lazy" className="feature_img" src="https://static.toiimg.com/photo/87304656.cms" alt=""></img>

                </div>

                <div className="col-lg-6">

                    <div className="feature_right">
                        <h2>Delicious sweets!</h2>

                    </div>

                </div>

            </div>

        </div>
    )
}

export default Feature;
